import React from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import usePrompt from "../../../hooks/usePrompt";
import { UserRole, useAuth, hasAnyRole } from "../../../context/AuthContext";
import { ChannelState } from "../../../models/SKChannel";
import { useLeftbarBar } from "../../../context/LeftSidebarContext";
import packageJson from "../../../../package.json";

const NavBar = () => {
  const authContext = useAuth();
  const { showLeftbar } = useLeftbarBar();

  return showLeftbar ? (
    // <aside class="flex flex-col top-0 left-0 z-40 md:w-64 md:h-full bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700">
    // <div class="h-full py-3 overflow-x-auto overflow-y-auto bg-white md:pt-5 dark:bg-gray-800">
    //   <ul class="flex flex-row justify-start px-2 pt-2 text-sm font-semibold md:gap-y-2 md:flex-col whitespace-nowrap">

    <aside
      className={`flex flex-col top-0 left-0 z-40 md:w-64 md:h-full bg-white border-r border-gray-200 sm:translate-x-0 dark:bg-gray-800 dark:border-gray-700`}
    >
      {/* {showModal && (
        <BlockNavigationModal
          message="Are you sure you want to leave this page? Unsaved changes will be lost."
          onConfirm={confirmNavigation}
          onCancel={cancelNavigation}
        />
      )} */}
      <div className="h-full py-3 overflow-x-auto overflow-y-auto bg-white md:pt-5 dark:bg-gray-800 scrollbar-hide">
        <ul className="flex flex-row justify-start px-2 pt-2 text-sm font-semibold md:gap-y-2 md:flex-col whitespace-nowrap">
          {authContext && authContext.userRoles && hasAnyRole(authContext?.userRoles, Object.values(UserRole)) && (
            <li>
              <NavLink
                to="home"
                className={
                  ({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") +
                    " border-[1px] text-gray-900 p-2 md:ml-0 flex  items-center  rounded-lg dark:text-white"
                  // this ml-[560px] is a hack we are adjusting the margin in case of mobile view where its an issue of not visible first few links
                }
              >
                <span className="px-2">Home</span>
              </NavLink>
            </li>
          )}

          {!hasAnyRole(authContext?.userRoles ?? [], Object.values(UserRole)) &&
            authContext?.myInvites &&
            authContext.myInvites.length > 0 &&
            false && (
              <li>
                <NavLink
                  to="invitelist"
                  className={
                    ({ isActive }) =>
                      (isActive ? "border-skgray  " : " border-white ") +
                      " border-[1px] text-gray-900 p-2 md:ml-0 flex  items-center  rounded-lg dark:text-white"
                    // this ml-[560px] is a hack we are adjusting the margin in case of mobile view where its an issue of not visible first few links
                  }
                >
                  <span className="px-2">Invitations</span>
                </NavLink>
              </li>
            )}

          {authContext &&
            authContext.userRoles &&
            (!hasAnyRole(authContext?.userRoles ?? [], Object.values(UserRole)) ||
              hasAnyRole(authContext?.userRoles, [UserRole.BrandAdmin, UserRole.CreatorAdmin, UserRole.Operator])) && (
              <li>
                <NavLink
                  to="channels"
                  className={
                    ({ isActive }) =>
                      (isActive ? "border-skgray  " : " border-white ") +
                      " border-[1px] text-gray-900 p-2 md:ml-0 flex  items-center  rounded-lg dark:text-white"
                    // this ml-[560px] is a hack we are adjusting the margin in case of mobile view where its an issue of not visible first few links
                  }
                >
                  <span className="px-2">Channel</span>
                </NavLink>
              </li>
            )}

          {authContext &&
            authContext.userRoles &&
            hasAnyRole(authContext.userRoles, [UserRole.Operator, UserRole.CreatorAdmin, UserRole.BrandAdmin]) &&
            authContext.myChannel?.status === ChannelState.ACTIVE && (
              <li>
                <NavLink
                  to="content"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex  items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2">Content</span>
                </NavLink>
              </li>
            )}
          {authContext &&
            authContext.userRoles &&
            ((hasAnyRole(authContext?.userRoles, [UserRole.BrandAdmin, UserRole.CreatorAdmin]) &&
              authContext.myChannel?.status === ChannelState.ACTIVE) ||
              hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin])) &&
            false && (
              <li>
                <NavLink
                  to="payment"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2">Payments</span>
                  {/* <span className="inline-flex items-center justify-center w-3 h-3 p-3 text-sm font-medium text-blue-800 bg-blue-100 rounded-full ms-3 dark:bg-blue-900 dark:text-blue-300">
                3
              </span> */}
                </NavLink>
              </li>
            )}
          {authContext &&
            authContext.userRoles &&
            ((hasAnyRole(authContext?.userRoles, [UserRole.BrandAdmin, UserRole.CreatorAdmin]) &&
              authContext.myChannel?.status === ChannelState.ACTIVE) ||
              hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin])) &&
            false && (
              <li>
                <NavLink
                  to="members"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2 ">Team Members</span>
                </NavLink>
              </li>
            )}
          {authContext && authContext.userRoles && hasAnyRole(authContext?.userRoles, Object.values(UserRole)) && false && (
            <li>
              <NavLink
                to="analytics"
                className={({ isActive }) =>
                  (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                }
              >
                <span className="px-2">Analytics</span>
              </NavLink>
            </li>
          )}
          {authContext &&
            authContext.userRoles &&
            hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin, UserRole.SkarvoOperator, UserRole.SkarvoContentModerator]) && (
              <li>
                <NavLink
                  to="contentModeration"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2 ">Content Inbox</span>
                </NavLink>
              </li>
            )}
          {authContext &&
            authContext.userRoles &&
            hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin, UserRole.SkarvoOperator, UserRole.SkarvoContentModerator]) && (
              <li>
                <NavLink
                  to="applications"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2 ">Application Inbox</span>
                </NavLink>
              </li>
            )}
          {authContext &&
            authContext.userRoles &&
            hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin, UserRole.SkarvoOperator, UserRole.SkarvoChannelModerator]) && (
              <li>
                <NavLink
                  to="channelModeration"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2 ">Channel Inbox</span>
                </NavLink>
              </li>
            )}

          {authContext &&
            authContext.userRoles &&
            hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin, UserRole.SkarvoOperator, UserRole.SkarvoChannelModerator]) && (
              <li>
                <NavLink
                  to="userFeedback"
                  className={({ isActive }) =>
                    (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                  }
                >
                  <span className="px-2 ">Feedback Inbox</span>
                </NavLink>
              </li>
            )}
          {authContext && authContext.userRoles && hasAnyRole(authContext?.userRoles, [UserRole.SkarvoAdmin]) && (
            <li>
              <NavLink
                to="widgetShowcase"
                className={({ isActive }) =>
                  (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                }
              >
                <span className="px-2 ">Widgets Library</span>
              </NavLink>
            </li>
          )}

          {/* {authContext && authContext.userRoles && hasAnyRole(authContext?.userRoles, Object.values(UserRole)) && (
            <li>
              <NavLink
                to="settings"
                className={({ isActive }) =>
                  (isActive ? "border-skgray  " : " border-white ") + " border-[1px] flex items-center p-2  rounded-lg dark:text-white "
                }
              >
                <span className="px-2">Settings</span>
              </NavLink>
            </li>
          )} */}
        </ul>
      </div>
    </aside>
  ) : (
    <></>
  );
};

export default NavBar;
